/**
 * @file A count with its noun, pluralised by adding `s` when the count is not
 * one ("1 page", "2 flagged cells"). The one copy of that rule for the PDF
 * intake's server-written text: the schedule and pricebook jobs' "waiting
 * on", the approval's refusal and the publish's refusal. Only for nouns whose
 * plural is the noun plus `s`.
 */
export function countedNoun(count: number, noun: string): string {
    return `${count} ${noun}${count === 1 ? '' : 's'}`;
}
